export default {
  add: {
    id: 'bo_seller_profile_page_epr_modal_add',
    defaultMessage: 'Add',
  },
  addDetails: {
    id: 'bo_seller_profile_page_epr_modal_add_details',
    defaultMessage: 'Add details',
  },
  category: {
    id: 'bo_seller_profile_page_epr_modal_category',
    defaultMessage: 'Category',
  },
  categoryLabel: {
    id: 'bo_seller_profile_page_epr_modal_category_label',
    defaultMessage: 'Choose your category and add your EPR number.',
  },
  eeeNumberFR: {
    id: 'bo_seller_profile_page_epr_modal_eee_number_fr',
    defaultMessage:
      'Waste from Electrical and Electronic Equipment (WEEE) category EPR number',
  },
  eeeNumberDE: {
    id: 'bo_seller_profile_page_epr_modal_eee_number_de',
    defaultMessage:
      'Waste from Electrical and Electronic Equipment (WEEE) category EPR number starting July 1, 2023',
  },
  batteriesNumberFR: {
    id: 'bo_seller_profile_page_epr_modal_batteries_number_fr',
    defaultMessage: 'Batteries category EPR number',
  },
  batteriesNumberDE: {
    id: 'bo_seller_profile_page_epr_modal_batteries_number_de',
    defaultMessage: 'Batteries category EPR number starting July 1, 2023',
  },
  eprInformationDeleteErrorTitle: {
    id: 'bo_seller_profile_page_epr_modal_delete_error_title',
    defaultMessage: 'Oops!',
  },
  eprInformationDeleteErrorMessage: {
    id: 'bo_seller_profile_page_epr_modal_delete_error_message',
    defaultMessage: 'Something went wrong while deleting an EPR category.',
  },
  eprInformationPostErrorMessage: {
    id: 'bo_seller_profile_page_epr_modal_post_error_message',
    defaultMessage: 'Something went wrong while adding an EPR category.',
  },
  eprInformationPostErrorTitle: {
    id: 'bo_seller_profile_page_epr_modal_post_error_title',
    defaultMessage: 'Oops!',
  },
  eprInformationUpdateSuccessMessage: {
    id: 'bo_seller_profile_page_epr_modal_update_success_message',
    defaultMessage: 'EPR details have been correctly updated.',
  },
  eprInformationUpdateSuccessTitle: {
    id: 'bo_seller_profile_page_epr_modal_update_success_title',
    defaultMessage: 'Perfect!',
  },
  eprNumber: {
    id: 'bo_seller_profile_page_epr_modal_epr_number',
    defaultMessage: 'EPR Number',
  },
  eprId: {
    id: 'bo_seller_profile_page_epr_modal_epr_id',
    defaultMessage: 'EPR ID',
  },
  loadingText: {
    id: 'bo_seller_profile_page_epr_modal_loading_text',
    defaultMessage: 'Adding your EPR information...',
  },
  eprNumberHintDE: {
    id: 'bo_seller_profile_page_epr_modal_epr_number_hint_de',
    defaultMessage:
      'Tip: The number should include 7–13 digits and be in this format: DE123456789',
  },
  eprNumberHintFR: {
    id: 'bo_seller_profile_page_epr_modal_epr_number_hint_fr',
    defaultMessage:
      'Tip: This is the unique ID number on your certificate. It can include a combination of numbers and letters and should be in this format: FR123456_12ABCD',
  },
  eprNumberHintES: {
    id: 'bo_seller_profile_page_epr_modal_epr_number_hint_sp',
    defaultMessage:
      'Tip: The number should include 18 characters and be in this format: ENV/2025/000074944',
  },
  eprNumberNotUnique: {
    id: 'bo_seller_profile_page_epr_modal_epr_number_not_unique',
    defaultMessage: 'You’ve already entered this EPR number. Add another one.',
  },
  eprNumbersToAddText: {
    id: 'bo_seller_profile_page_epr_modal_epr_numbers_to_add',
    defaultMessage: 'The following EPR numbers will be added to your profile:',
  },
  exempt: {
    id: 'bo_seller_profile_page_epr_modal_exempt',
    defaultMessage: 'Exempt',
  },
  fullDeeeLabel: {
    id: 'bo_seller_profile_page_epr_modal_full_deee_label',
    defaultMessage: 'Waste from Electrical and Electronic Equipment (WEEE)',
  },
  exemptFrom: {
    id: 'bo_seller_profile_page_epr_modal_exempt_from',
    defaultMessage: "I'm exempt from {category}",
  },
  missingDeCategories: {
    id: 'bo_seller_profile_page_epr_modal_missing_de_categories',
    defaultMessage:
      'You need to provide the following information to sell in Germany:',
  },
  packagingNumberFR: {
    id: 'bo_seller_profile_page_epr_modal_packaging_number_certificate_fr',
    defaultMessage: 'Packaging category EPR number',
  },
  packagingNumberDE: {
    id: 'bo_seller_profile_page_epr_modal_packaging_number_certificate_de',
    defaultMessage: 'Packaging category EPR number and certificate',
  },
  title: {
    id: 'bo_seller_profile_page_epr_modal_title',
    defaultMessage: 'Add EPR details for {market}',
  },
  uploadCertificate: {
    id: 'bo_seller_profile_page_epr_modal_upload_certificate',
    defaultMessage: 'Upload certificate',
  },
  fieldIsRequired: {
    id: 'merchant_register_form_fields_required',
    defaultMessage: 'This field is required',
  },
}
